/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';

import styles from '../../../../styles';
import { RadioGroup } from '../../../../components/Form';
import QuickFind from '../../../../../shared/components/QuickFind';

const Wrapper = styled.div`
  background-color: #F4F6F9;
  border: 1px solid ${styles.colors.linkWater};
  border-radius: .25rem;
  margin: 2rem;
`;

const Controls = styled.div`
  padding: 0 1rem 0 1rem;
`;

const Label = styled.div`
  padding: 0.75rem 0 0.5rem 0;
  ${styles.fonts.headingLabelCaps}
`;

const SmallLabel = styled.div`
  font-size: 12px;
  color: #40607F
`;

const InstanceList = styled(RadioGroup)`
  height: 16rem;
  overflow-y: scroll;
  position: relative;
  padding: .25rem 1rem;
  margin-top: 1rem;
`;

class InstancePage extends React.Component {
  render() {
    return (
      <Wrapper>
        <Controls>
          <Label>
            {this.props.label || 'Choose an Instance'}
          </Label>
          {this.props.onInstanceFilterChange && <QuickFind placeholder='Quick Find'
            onChange={this.props.onInstanceFilterChange} />}
          {this.props.instanceOrProduct === 'product' &&
            <SmallLabel>You will subscribe to all instances of the product.</SmallLabel>}
        </Controls>
        <InstanceList
          instanceOrProduct={this.props.instanceOrProduct || 'instance'}
          name={this.props.name || 'instance'}
          value={this.props.instanceKey}
          options={this.props.instanceOptions}
          onChange={this.props.setInstanceKey}
        />
      </Wrapper>
    );
  }
}

export default InstancePage;
